import { defineMessages } from 'react-intl';

export default defineMessages({
  shopperServiceOverrideSelectText: {
    description: 'First part of the overide language where we show which service to select',
    defaultMessage: 'Select',
    id: 'XUte5H',
  },
  ifCheapestLabelIsWithinText: {
    description: 'Second part of the overide language where we show the cheapest label',
    defaultMessage: 'if the cheapest label is within',
    id: '6rkL4d',
  },
});
